import type { ReactNode } from 'react';
import { cx } from './cx';
import s from './Stat.module.css';

export function Stat({ label, value, hint, size = 'md', className }: { label: ReactNode; value: ReactNode; hint?: ReactNode; size?: 'sm' | 'md' | 'lg'; className?: string }) {
  return (
    <div className={cx(s.stat, s[size], className)}>
      <span className={s.label}>{label}</span>
      <span className={s.value}>{value}</span>
      {hint && <span className={s.hint}>{hint}</span>}
    </div>
  );
}
